"use client"
import { idType } from '@/interFace/interFace';
import React from 'react';
import Breadcrumb from '../common/breadcrumb/Breadcrumb';
import BlogDetailsArea from './BlogDetailsArea';
const BlogDetailsMain = () => {
    return (
        <>
            <Breadcrumb breadHome={'Home'} breadMenu={'Blog Details'} />
            <BlogDetailsArea />
        </>
    );
};

export default BlogDetailsMain;